import { combineEpics } from "redux-observable";
import { messageCountLoadEpicReducer } from "../ducks/messageCount.duck.js";
const messgeCountEpic = combineEpics(messageCountLoadEpicReducer.epic);
export {
  messgeCountEpic
};
//# sourceMappingURL=messageCount.epics.js.map
